<template>
  <!-- 对话框 -->
  <el-dialog title="审核判定" :visible.sync="show" :before-close="closeDialog" style="width:60%; margin: 0 auto;">

    <!-- 基本信息表单 -->
    <div class="form-box" style="max-height: 70vh; overflow-y: auto;">
      <el-form label-width="80px">


        <div style="display: flex; justify-content: space-around;" v-if="determine_data!=null">

          <el-image :preview-src-list="srcList" v-if="img_url.id_card_portrait_imageUrl"
            :src="img_url.id_card_portrait_imageUrl" class="avatar" style="border: 1px solid #ccc; border-radius: 5px;">
          </el-image>







          <el-image :preview-src-list="srcList" v-if="img_url.id_card_china_imageUrl"
            :src="img_url.id_card_china_imageUrl" class="avatar" style="border: 1px solid #ccc; border-radius: 5px;">
          </el-image>







          <el-image :preview-src-list="srcList" v-if="img_url.driver_card_imageUrl" :src="img_url.driver_card_imageUrl"
            class="avatar" style="border: 1px solid #ccc; border-radius: 5px;"></el-image>






          <el-image :preview-src-list="srcList" v-if="img_url.id_card_hold_imageUrl"
            :src="img_url.id_card_hold_imageUrl" class="avatar" style="border: 1px solid #ccc; border-radius: 5px;">
          </el-image>


        </div>

        <div v-if="determine_data!=null">
          <el-form-item label="真实姓名:" label-width='120px'>

            {{determine_data.real_name}}

          </el-form-item>

          <el-form-item label="身份证号:" label-width='120px'>

            {{determine_data.id_card}}

          </el-form-item>

          <el-form-item label="驾驶证型号:" label-width='120px'>

            {{determine_data.driver_card_mode}}

          </el-form-item>

          <el-form-item label="司机备注:" label-width='120px'>

            {{determine_data.remarks}}

          </el-form-item>

        </div>


        <el-form-item label="审核判定:" label-width='120px' v-if="determine_data!=null">

          <p v-if="!submit_btn_show">已通过</p>

          <el-radio-group v-model="submit_data.verify_status" v-else>
            <el-radio-button label="1">通过</el-radio-button>
            <el-radio-button label="2">拒绝</el-radio-button>
          </el-radio-group>

        </el-form-item>




        <el-form-item label="系统备注:" label-width='120px' v-if="determine_data!=null">
          <el-input type="textarea" autosize v-model="submit_data.verify_remarks"
            :placeholder="submit_rules.verify_remarks.placeholder">
          </el-input>
        </el-form-item>

        <div v-if="determine_data == null" style="text-align: center;margin-bottom: 20px;">该司机无审核信息,不能进行审核</div>

      </el-form>

      <div style="display: flex;justify-content: center">
        <el-button type="primary" @click="determineonSubmit" v-if="submit_btn_show">保存</el-button>
        <el-button @click="closeDialog">关闭</el-button>
      </div>

    </div>

  </el-dialog>
</template>

<script>
  var _this;
  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;
        _this.submit_data.driver_code = _this.data;


        this.$post(
            "/driver/getDriverVerifyDetails", {
              driver_code: this.data
            }
          )
          .then(res => {

            // 在submit_data对象中赋值driver_code
            this.submit_data.driver_code = this.data;

            // 判断返回的data中是否有值
            if (res.data == null) {

              this.determine_data = null;

            } else {

              _this.submit_data.verify_status = res.data.verify_status;
              _this.submit_data.verify_remarks = res.data.verify_remarks;

              this.determine_data = {};
              // 返回的data中的值赋给submit_data对象,并在returnData中做标记
              this.determine_data.real_name = res.data.real_name;
              this.determine_data.id_card = res.data.id_card;
              this.determine_data.driver_card_mode = res.data.driver_card_mode;
              this.determine_data.driver_time = res.data.driver_time.Ymd;
              this.determine_data.remarks = res.data.remarks;

              this.determine_data.id_card_portrait_hash = res.data.id_card_portrait.hash;
              this.determine_data.id_card_china_hash = res.data.id_card_china.hash;
              this.determine_data.driver_card_hash = res.data.driver_card.hash;
              this.determine_data.id_card_hold_hash = res.data.id_card_hold.hash;
              this.verify_status = res.data.verify_status;
              this.verify_remarks = res.data.verify_remarks;

              this.value_driver_card = res.data.driver_card_mode;

              // 图片路径
              this.img_url.id_card_portrait_imageUrl = res.data.id_card_portrait.url;
              this.img_url.id_card_china_imageUrl = res.data.id_card_china.url;
              this.img_url.driver_card_imageUrl = res.data.driver_card.url;
              this.img_url.id_card_hold_imageUrl = res.data.id_card_hold.url;

              this.srcList.length = 0;
              this.srcList.push(this.img_url.id_card_portrait_imageUrl)
              this.srcList.push(this.img_url.id_card_china_imageUrl)
              this.srcList.push(this.img_url.driver_card_imageUrl)
              this.srcList.push(this.img_url.id_card_hold_imageUrl)

              if (_this.submit_data.verify_status == '1') {

                _this.submit_btn_show = false;

              } else {

                _this.submit_btn_show = true;

              }

            }


          })



      },

    },
    data() {
      return {

        show: false,
        verify_status: '',
        verify_remarks: '',
        value_driver_card: '',
        srcList: [],

        submit_btn_show: true,

        //上传图片
        img_url: {
          id_card_portrait_imageUrl: '',
          id_card_china_imageUrl: '',
          driver_card_imageUrl: '',
          id_card_hold_imageUrl: ''
        },

        determine_data: {},

        // 表单数据
        submit_data: {
          driver_code: '',
          verify_status: '',
          verify_remarks: ''
        },

        submit_rules: {
          verify_status: {
            placeholder: '审核判定',
            rules: {
              required: true,
              message: '未选择审核判定状态',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          verify_remarks: {
            placeholder: '审核原因',
            rules: {
              required: true,
              message: '角色名100个汉字以下',
              regulation: 'elt_str',
              rulesData: 200
            }
          },

        },

      };
    },
    created() {
      _this = this;

    },
    methods: {


      // 关闭方法
      closeDialog() {

        _this.show = false;

        for (const key in _this.submit_data) {
          _this.submit_data[key] = '';
        }

      },

      // 提交按钮
      determineonSubmit() {

        _this.$post(
            '/driver/executeDriverVerifySubmit',
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {
            _this.$message.success(res.msg)
            // 向父组件通讯刷新表格内容
            _this.$emit('onSubmit');
            // 关闭对话框
            _this.closeDialog();

          }).catch((err) => {

          })

      }
    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }

  .avatar-uploader img {
    display: block;
    width: 100%;
    height: 100%;

  }

  .el-form-item__content {
    position: relative;
  }
</style>